import { db } from "@/firebase"
import firebase from "firebase";
const leads_ref = db.collection("leads")



const createLead = async (data) => {
    try {
        const get_data = await leads_ref.add(data);
        await editLead(get_data.id, { ...data, id_doc: get_data.id })
        return get_data.id;
    } catch (error) {
        throw new Error("createLead Fail!" + error)
    }
}
const editLead = async (idDoc, data) => {
    try {
        await leads_ref.doc(idDoc).update(data);
        return true;
    } catch (error) {
        throw new Error("editLead Fail!" + error)
    }
}

async function getLeads() {
    let leads_list = []
    try {
        const unitsRef = await leads_ref.get()
        unitsRef.forEach((doc) => leads_list.push(doc.data()));
        return leads_list
    } catch (error) {
        console.error(error)
    }
}
async function getLeadsById(idUser) {
    try {
        const user = await leads_ref.doc(idUser).get()
        return user.data()
    } catch (error) {
        console.error(error)
    }
}

async function removeHistoricListFromLeads(idLead) {
    try {
        const doc_lead_ref = await leads_ref.doc(idLead)

        await doc_lead_ref.update({
            historics: firebase.firestore.FieldValue.delete()
        })
    } catch (error) {
        console.error(error)
    }

    return true;
}

async function searchLeadByDocumentAndFranchisee(document, id_franchisee) {
    try {
        const leadsSnapshot = await leads_ref
            .where('document', '==', document)
            .get();

        if (leadsSnapshot.empty) {
            return null; // Lead doesn't exist
        }

        const leads = [];
        leadsSnapshot.forEach(doc => {
            const leadData = doc.data();
            if (leadData.id_franchisee) {
                leads.push({
                    ...leadData,
                    id_doc: doc.id
                });
            }
        });

        if (leads.length === 0) {
            return null; // Lead exists but not linked to any franchisee
        }

        // Check if any lead is linked to a different franchisee
        const linkedToOtherFranchisee = leads.some(lead => lead.id_franchisee !== id_franchisee);

        if (linkedToOtherFranchisee) {
            return 'exists_other_franchisee'; // Lead exists for another franchisee
        }

        // Lead exists and is linked to this franchisee
        return leads[0];
    } catch (error) {
        console.error('Error searching lead:', error);
        throw new Error("searchLeadByDocumentAndFranchisee Fail!" + error);
    }
}

async function searchLeadByPhoneAndFranchisee(phone, id_franchisee) {
    try {
        console.log("Searching by phone:", phone);
        const leadsSnapshot = await leads_ref
            .where('phone', '==', phone)
            .get();

        if (leadsSnapshot.empty) {
            return null; // Lead doesn't exist
        }

        const leads = [];
        leadsSnapshot.forEach(doc => {
            const leadData = doc.data();
            if (leadData.id_franchisee) {
                leads.push({
                    ...leadData,
                    id_doc: doc.id
                });
            }
        });

        if (leads.length === 0) {
            return null; // Lead exists but not linked to any franchisee
        }

        // Check if any lead is linked to a different franchisee
        const linkedToOtherFranchisee = leads.some(lead => lead.id_franchisee !== id_franchisee);

        if (linkedToOtherFranchisee) {
            return 'exists_other_franchisee'; // Lead exists for another franchisee
        }

        // Lead exists and is linked to this franchisee
        return leads[0];
    } catch (error) {
        console.error('Error searching lead by phone:', error);
        throw new Error("searchLeadByPhoneAndFranchisee Fail!" + error);
    }
}

async function searchLeadByEmailAndFranchisee(email, id_franchisee) {
    try {
        const leadsSnapshot = await leads_ref
            .where('email', '==', email)
            .get();

        if (leadsSnapshot.empty) {
            return null; // Lead doesn't exist
        }

        const leads = [];
        leadsSnapshot.forEach(doc => {
            const leadData = doc.data();
            if (leadData.id_franchisee) {
                leads.push({
                    ...leadData,
                    id_doc: doc.id
                });
            }
        });

        if (leads.length === 0) {
            return null; // Lead exists but not linked to any franchisee
        }

        // Check if any lead is linked to a different franchisee
        const linkedToOtherFranchisee = leads.some(lead => lead.id_franchisee !== id_franchisee);

        if (linkedToOtherFranchisee) {
            return 'exists_other_franchisee'; // Lead exists for another franchisee
        }

        // Lead exists and is linked to this franchisee
        return leads[0];
    } catch (error) {
        console.error('Error searching lead by email:', error);
        throw new Error("searchLeadByEmailAndFranchisee Fail!" + error);
    }
}

async function getLeadsByFranchisee(id_franchisee) {
    try {
        const leadsSnapshot = await leads_ref
            .where('id_franchisee', '==', id_franchisee)
            .get();

        const leads = [];
        leadsSnapshot.forEach(doc => {
            const leadData = doc.data();
            leads.push({
                ...leadData,
                id_doc: doc.id
            });
        });

        return leads;
    } catch (error) {
        console.error('Error getting leads by franchisee:', error);
        throw new Error("getLeadsByFranchisee Fail!" + error);
    }
}

export default {
    createLead,
    editLead,
    getLeads,
    getLeadsById,
    removeHistoricListFromLeads,
    searchLeadByDocumentAndFranchisee,
    searchLeadByPhoneAndFranchisee,
    searchLeadByEmailAndFranchisee,
    getLeadsByFranchisee
};